import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { BreadcrumbNav } from "@/components/BreadcrumbNav";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const SEOKatyPage = () => {
  const [language, setLanguage] = useState<'es' | 'en'>('es');
  const toggleLanguage = () => setLanguage(language === 'es' ? 'en' : 'es');
  const canonicalUrl = generateCanonicalUrl('/seo-katy');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "SEO en Katy TX",
    "provider": { "@id": "https://luisroc.com/#organization" },
    "areaServed": { "@type": "City", "name": "Katy", "containedIn": { "@type": "State", "name": "Texas" } }
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>SEO Katy TX | Posicionamiento Local en Google – Luis ROC</title>
        <meta name="description" content="Agencia SEO en Katy, Texas. Posicionamiento local en Google Maps para negocios en Katy. Reunión inicial gratuita." />
        <meta name="keywords" content="seo katy tx, seo katy texas, agencia seo katy" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={toggleLanguage} />
        
        <main className="container mx-auto px-4 py-8">
          <BreadcrumbNav 
            items={[
              { name: "Servicios", url: "/servicios" },
              { name: "Localidades", url: "/servicios-locales-houston" },
              { name: "SEO Katy", url: "/seo-katy" }
            ]}
            language="es"
          />

          <section className="py-16 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primary to-primary-glow bg-clip-text text-transparent">
              SEO en Katy TX — Posiciona tu negocio local
            </h1>
            
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-8">
              Katy es una de las ciudades de más rápido crecimiento en Texas. Optimiza tu presencia en Google Maps 
              y búsquedas locales para capturar clientes en ZIP 77449, 77450, 77493, 77494.
            </p>

            <Button size="lg" onClick={() => window.location.href = '/diagnostico-seo-gratis'}>
              Reunión inicial gratuita de 30 minutos
            </Button>
          </section>

          <section className="py-16 bg-gradient-to-r from-primary to-primary-glow text-primary-foreground rounded-lg text-center">
            <h2 className="text-3xl font-bold mb-4">Lidera Google en Katy</h2>
            <Button size="lg" variant="secondary" onClick={() => window.location.href = '/contacto'}>
              Solicitar Consulta
            </Button>
          </section>
        </main>

        <KnowledgeConnections path="/seo-katy" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};

export default SEOKatyPage;
